// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PaymentScheduleTable_CommitmentFragment = { __typename?: 'Commitment', id: string, committedInCents: number, depositInBasisPoints?: number | null | undefined, canEditDraws: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, project:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
  , draws: Array<{ __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string } } }>, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string } } }> };

export type PaymentScheduleTable_DrawFragment = { __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string } } };

export type PaymentScheduleTaskOptionsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  budgetItemIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type PaymentScheduleTaskOptionsQuery = { __typename?: 'Query', planTasks: { __typename?: 'PlanTasksResult', entities: Array<{ __typename?: 'PlanTask', id: string, name: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string } }> } };

export type PaymentScheduleTable_PlanTaskFragment = { __typename?: 'PlanTask', id: string, name: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string } };

export const PaymentScheduleTable_DrawFragmentDoc = gql`
    fragment PaymentScheduleTable_Draw on CommitmentDraw {
  id
  amountInBasisPoints
  description
  task {
    ...Named
    status {
      code
      name
    }
  }
}
    ${NamedFragmentDoc}`;
export const PaymentScheduleTable_CommitmentFragmentDoc = gql`
    fragment PaymentScheduleTable_Commitment on Commitment {
  id
  committedInCents
  depositInBasisPoints
  canEditDraws {
    allowed
    disabledReasons {
      message
    }
  }
  project {
    id
  }
  draws {
    ...PaymentScheduleTable_Draw
  }
  lineItems {
    id
    projectItem {
      id
      item {
        id
      }
    }
  }
}
    ${PaymentScheduleTable_DrawFragmentDoc}`;
export const PaymentScheduleTable_PlanTaskFragmentDoc = gql`
    fragment PaymentScheduleTable_PlanTaskFragment on PlanTask {
  ...Named
  status {
    code
    name
  }
}
    ${NamedFragmentDoc}`;
export const PaymentScheduleTaskOptionsDocument = gql`
    query PaymentScheduleTaskOptions($projectId: ID!, $budgetItemIds: [ID!]!) {
  planTasks(filter: {project: [$projectId], budgetItem: $budgetItemIds}) {
    entities {
      ...PaymentScheduleTable_PlanTaskFragment
    }
  }
}
    ${PaymentScheduleTable_PlanTaskFragmentDoc}`;

/**
 * __usePaymentScheduleTaskOptionsQuery__
 *
 * To run a query within a React component, call `usePaymentScheduleTaskOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentScheduleTaskOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentScheduleTaskOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      budgetItemIds: // value for 'budgetItemIds'
 *   },
 * });
 */
export function usePaymentScheduleTaskOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables> & ({ variables: PaymentScheduleTaskOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables>(PaymentScheduleTaskOptionsDocument, options);
      }
export function usePaymentScheduleTaskOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables>(PaymentScheduleTaskOptionsDocument, options);
        }
// @ts-ignore
export function usePaymentScheduleTaskOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables>;
export function usePaymentScheduleTaskOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaymentScheduleTaskOptionsQuery | undefined, PaymentScheduleTaskOptionsQueryVariables>;
export function usePaymentScheduleTaskOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables>(PaymentScheduleTaskOptionsDocument, options);
        }
export type PaymentScheduleTaskOptionsQueryHookResult = ReturnType<typeof usePaymentScheduleTaskOptionsQuery>;
export type PaymentScheduleTaskOptionsLazyQueryHookResult = ReturnType<typeof usePaymentScheduleTaskOptionsLazyQuery>;
export type PaymentScheduleTaskOptionsSuspenseQueryHookResult = ReturnType<typeof usePaymentScheduleTaskOptionsSuspenseQuery>;
export type PaymentScheduleTaskOptionsQueryResult = ApolloReactCommon.QueryResult<PaymentScheduleTaskOptionsQuery, PaymentScheduleTaskOptionsQueryVariables>;